module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("This is the admin page")]), _vm._v(" "), _c('ul', _vm._l((_vm.email_list), function(user) {
    return _c('li', [_vm._v("\n            " + _vm._s(user.name) + " || " + _vm._s(user.email) + " || " + _vm._s(user.status) + "\n        ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-045e4c91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Admin.vue
// module id = 95
// module chunks = 0